import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessSchema } from '../../entities/process/process.schema';
import { ProcessStepAssignmentSchema, InProgressRecordingSchema } from '../../entities/process-step-assignment';
import { SurveyWithVariantCheckSchema } from '../../entities/survey';
import { PopulatedEntitySuggestionSchema } from '../../entities/entity-suggestion';
/**
 * List Tasks Request Schema
 * GET /api/v2/task
 * No request body required
 */ export const ListTasksRequestSchema = z.void();
/**
 * List Tasks Response Schema
 * Returned on successful retrieval
 * Contains open processes, pending assignments, in-progress recordings, and pending surveys
 *
 * A who-else nomination is no longer a task section of its own (ADR 0023): a
 * pending User nominee is surveyed at reconciliation, so their entry arrives in
 * `pendingSurveys` and the survey answer is what moves the nomination.
 */ export const ListTasksResponseSchema = z.object({
    openProcesses: z.array(ProcessSchema),
    assignments: z.array(ProcessStepAssignmentSchema),
    inProgressRecordings: z.array(InProgressRecordingSchema),
    pendingSurveys: z.array(SurveyWithVariantCheckSchema),
    entitySuggestions: z.array(PopulatedEntitySuggestionSchema)
});
/**
 * List Tasks Error Schema
 * Returned when retrieval fails
 */ export const ListTasksErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-tasks.schema.js.map